import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BuergscheinCreateSuper } from './bgsch-create.super';
import { CreateBuergscheinModel } from '../../../../model.module/create-buergschein.model';

@Component({
    selector: 'bgsch-create-abschl-1',
    templateUrl: './bgsch-create-abschl-1.component.html',
    styleUrls: ['./bgsch-create.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuergschaftCreateComponentAbschl1 extends BuergscheinCreateSuper {

    @Input()
    model: CreateBuergscheinModel = new CreateBuergscheinModel();

}
